import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { toggleCollapsedNav, updateWindowWidth, updateWindowHeight } from 'actions';
import { MenuDataContext } from '../MenuDataProvider';
import CustomScrollbars from '../../../util/CustomScrollbars';
import SideBarNavigation from '../../../components/Navigation/index';
import SidebarFooter from '../../../components/SidebarFooter';
import { pluginAppInIframe } from '../../../util/appUtils';
import { ReactComponent as Logo } from '../../../assets/images/kealogo-text-bg.svg';
import UserInfo from '../../../components/UserInfo';
import CloudOperationsPanel from '../../../features/operation-supervisor/CloudOperationsPanel';
import { useShellAppContext } from '../../../features/shell/context/useShellAppContext';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const SideBar = () => {
  const dispatch = useDispatch();
  const menuData = useContext(MenuDataContext);
  const { productProfile } = useShellAppContext();
  const t = useLocalizedMessage();
  const navCollapsed = useSelector(({ app }) => app.navCollapsed);

  useEffect(() => {
    const updateViewport = () => {
      dispatch(updateWindowWidth(window.innerWidth));
      dispatch(updateWindowHeight(window.innerHeight));
    };
    window.addEventListener('resize', updateViewport);
    return () => window.removeEventListener('resize', updateViewport);
  }, [dispatch]);

  const closeMobileNavigation = useCallback(() => {
    dispatch(toggleCollapsedNav(false));
  }, [dispatch]);

  const mobileDrawerHeader = (
    <div
      className="responsive-navigation-drawer-header"
      data-testid="responsive-navigation-drawer-header"
    >
      <Logo className="responsive-navigation-drawer-logo" role="img" aria-label="Kea Labs" />
      <IconButton
        className="responsive-navigation-drawer-close"
        onClick={closeMobileNavigation}
        aria-label={t('common.close')}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );

  const content = () => (
    <>
      {pluginAppInIframe() ? null : <UserInfo />}
      <CustomScrollbars className="scrollbar">
        <SideBarNavigation menuItems={menuData.full} />
      </CustomScrollbars>
      {productProfile?.id === 'cloud' && <CloudOperationsPanel variant="sidebar" />}
      <SidebarFooter />
    </>
  );

  if (!menuData) return (<div />);
  return (
    <>
      <div className="app-sidebar d-none d-xl-flex">
        <Drawer
          className="app-sidebar-content"
          variant="permanent"
          open
          classes={{ paper: 'side-nav' }}
        >
          {content()}
        </Drawer>
      </div>
      <Drawer
        id="mobile-navigation-drawer"
        className="responsive-navigation-drawer d-xl-none"
        variant="temporary"
        open={navCollapsed}
        onClose={closeMobileNavigation}
        classes={{ paper: 'side-nav responsive-side-nav' }}
        BackdropProps={{ className: 'responsive-navigation-drawer-backdrop' }}
        ModalProps={{ keepMounted: false, disablePortal: true }}
      >
        {mobileDrawerHeader}
        {content()}
      </Drawer>
    </>
  );
};

export default SideBar;
